import React from 'react';

import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';

interface OrderDetailedHeaderProps {
  inn: string;
  id: string;
  title: string;
  date: string;
  time: string;
  status: React.ReactNode;
  onClose?: () => void;
}

const OrderDetailedHeader: React.FC<OrderDetailedHeaderProps> = ({
  onClose,
  inn,
  date,
  time,
  status,
  title,
}) => (
  <TableHeaderWrapper
    leftContent={
      <>
        <div>{title}</div>
        <div className="order__header-inn">ИНН: {inn}</div>
      </>
    }
    onCloseClick={onClose}
    date={date}
    time={time}
    status={status}
    isHint
    hintPage="SPECIFICATION_LIST"
  />
);

export default OrderDetailedHeader;
